import { render, staticRenderFns } from "./input-errors.component.vue?vue&type=template&id=3c47cbea&scoped=true"
import script from "./input-errors.component.vue?vue&type=script&lang=ts"
export * from "./input-errors.component.vue?vue&type=script&lang=ts"
import style0 from "./input-errors.component.vue?vue&type=style&index=0&id=3c47cbea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c47cbea",
  null
  
)

export default component.exports